import React from 'react';
import Radium from 'radium';

import Modal from 'react-responsive-modal';

import { Formik } from 'formik';
import Yup from 'yup';
import {Input, SubmitButton, RGForm, TextArea, ComboBox} from 'views/FormElements';

import StockAPI from 'service/api/StockAPI';

class StockMoveModalForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {openModal: true};
        
        this.getInitValues = this.getInitValues.bind(this);
        this.onMoveStockProduct = this.onMoveStockProduct.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);
        this.validationScheme = this.validationScheme.bind(this);
    }

    getInitValues() {
        const stockProduct = this.props.stockProduct;

        return {productSize: stockProduct.productSize, quantity: 0, toOwnerAlias: '', comment: ''};
    }

    validationScheme() {
        const stockProduct = this.props.stockProduct;
		return Yup.object().shape({
            toOwnerAlias: Yup.string().required("Select which Stock Owner to Move to"),
            quantity: Yup.number().required('Enter a quantity').min(1, "Enter a positive quantity.").max(stockProduct.quantity, "Max quantity is "+stockProduct.quantity),
            comment: Yup.string()
		});
    }
    
    componentWillReceiveProps(nextProps) {
        this.setState({openModal: true})
    }

    onMoveStockProduct(value, {setSubmitting, resetForm}) {
        const stockProduct = this.props.stockProduct;

        const trasferRequest = {stockProductId: stockProduct.stockProductId, quantity: value.quantity, toOwnerAlias: value.toOwnerAlias, comment: value.comment};
        const currentOwner = this.props.stockOwner;
        StockAPI.transferStock(trasferRequest, function(success) {
            StockAPI.getStocks(value.toOwnerAlias);
            StockAPI.getStocks(currentOwner.ownerAlias);
            this.props.onSuccess();
        }.bind(this));
    }

    handleModalClose() {
        this.props.onSuccess();
    }

    render() {
        const stockProduct = this.props.stockProduct;
        const currentOwner = this.props.stockOwner;
        const allOwners = this.props.allOwners;

        const comboxValues = allOwners.filter(o => o.userId !== currentOwner.userId).map(o => {
            const optJson = {label: o.ownerAlias, value: o.ownerAlias}
            return optJson;
        });
        
        const initValues = this.getInitValues();
        return <Modal closeOnOverlayClick={false} open={this.state.openModal} onClose={this.handleModalClose} little 
                        classNames={{ overlay: 'add-stock-overlay', modal: 'add-stock-modal' }}>
                    
                    <Formik enableReinitialize initialValues={initValues} onSubmit={this.onMoveStockProduct}
                            validationSchema={this.validationScheme} 
                            render={({values, isSubmitting}) => {

                        return <RGForm>
                                <h3 style={{margin: '10px 0px 20px 0'}}>Move <b>{stockProduct.productSize}</b> {stockProduct.product.title} to!</h3>
                                <ComboBox name="toOwnerAlias" value={values.toOwnerAlias} 
													options={comboxValues} placeholder="Select Another Stock Owner" multi={false} />

                                <Input type="text" label="Product Size" name="productSize" disabled={true} />
                                <Input type="text" label="Quantity" name="quantity" />
                                <TextArea name="comment" placeholder="Comment" />
                                <SubmitButton color="primary" disabled={isSubmitting}>Update</SubmitButton>
                            </RGForm>
                        }} />
            </Modal>
    }
}

export default Radium(StockMoveModalForm);


// WEBPACK FOOTER //
// ./src/views/admin/StockMoveModalForm.js